
import { Component, Vue } from "vue-property-decorator";
import AddressDisplay from "../components/AddressDisplay.vue";
import { actions, AttachmentType, Contact, Facility } from "@/survey";
import GoogleMap from "@/components/GoogleMap.vue";
import EquipmentForm from "@/views/EquipmentForm.vue";
import EquipmentTable from "@/views/EquipmentTable.vue";
import { addLocationToGeoLocatable, getContactById, noop } from "@/store";
import DisplayImagesCarousel from "@/components/DisplayImagesCarousel.vue";
import FencingTable from "@/views/FencingTable.vue";
import FencingForm from "@/views/FencingForm.vue";
import GateForm from "@/views/GateForm.vue";
import GateTable from "@/views/GateTable.vue";
import ImageGallery from "@/components/ImageGallery.vue";
import AdminFacilityForm from "@/views/admin/AdminFacilityForm.vue";
import ContactDisplayNameEmailCall from "@/components/ContactDisplayNameEmailCall.vue";
import FacilityEquipmentMap from "@/components/FacilityEquipmentMap.vue";
import PunchFacilityForm from "@/views/PunchFacilityForm.vue";
import PunchItemTable from "@/views/PunchItemTable.vue";
import PunchItemForm from "@/views/PunchItemForm.vue";

@Component({
  components: {
    AdminFacilityForm,
    ImageGallery,
    AddressDisplay,
    DisplayImagesCarousel,
    GoogleMap,
    EquipmentForm,
    EquipmentTable,
    FencingForm,
    FencingTable,
    GateTable,
    GateForm,
    ContactDisplayNameEmailCall,
    FacilityEquipmentMap,
    PunchFacilityForm,
    PunchItemTable,
    PunchItemForm
  }
})
export default class SurveyFacility extends Vue {
  private mapKey = 1;
  client = Vue.prototype.$surveyClient;

  get draggable() {
    return this.$store.getters.canWrite;
  }

  get key() {
    return this.mapKey;
  }

  showMap() {
    this.mapKey++;
  }


  /*get punchFacility(){
    return this.$store.state.punchFacility
  }*/

  getContact(value: number): Contact | undefined {
    return getContactById(value);
  }

  toggleFacilityDetail() {
    this.$data.showFacilityDetail = !this.$data.showFacilityDetail;
  }

  get backTo() {
    return encodeURIComponent(this.$route.fullPath);
  }

  get punchItems() {
    return this.$store.state.punchItems;
  }

  get equipment() {
    return this.$store.state.equipment;
  }

  get fencing() {
    return this.$store.state.fencing;
  }

  get gates() {
    return this.$store.state.gates;
  }

  centerChanged(center: { lat: number; lng: number }) {
    this.facility.lat = center.lat;
    this.facility.lng = center.lng;
    this.$store.dispatch(actions.CREATE_OR_UPDATE_FACILITY, {
      toSave: this.facility,
      success: noop
    });
  }

  // get fac() {
  //   const facilityId = parseInt(this.$route.params.id);
  //   for (const facility of this.$store.state.facilities) {
  //     if (facility.id === facilityId) {
  //       return facility;
  //     }
  //   }
  //   return {};
  // }

  get attachmentMeta() {
    const facilityId = parseInt(this.$route.params.id);
    for (const facility of this.$store.state.facilities) {
      if (facility.id === facilityId) {
        return facility.attachmentMeta;
      }
    }
    return [];
  }

  get facility() {
    const facilityId = parseInt(this.$route.params.id);
    for (const facility of this.$store.state.facilities) {
      if (facility.id === facilityId) {
        return facility;
      }
    }
    return {};
  }

  data() {
    return {
      showFacilityDetail: true,
      dossierBusy: false,
      dossierError: "",
      attachmentDragOver: false,
      attachmentUploading: false,
      attachmentUploadMessage: "",
      attachmentUploadError: "",
      attachmentInputKey: 0,
      showAttachmentDropZone: false,
      facilityInfoEditing: false
    };
  }

  hideAttachmentDropZone() {
    if (this.$data.attachmentUploading) {
      return;
    }
    this.$data.showAttachmentDropZone = false;
    this.$data.attachmentDragOver = false;
  }

  browseForAttachments() {
    if (this.$data.attachmentUploading) {
      return;
    }
    (this.$refs.attachmentInput as HTMLInputElement).click();
  }

  onAttachmentBrowse(event: Event) {
    const input = event.target as HTMLInputElement;
    this.uploadAttachments(input.files);
  }

  onAttachmentDrop(event: DragEvent) {
    this.$data.attachmentDragOver = false;
    if (this.$data.attachmentUploading) {
      return;
    }
    this.uploadAttachments(event.dataTransfer ? event.dataTransfer.files : null);
  }

  async uploadAttachments(fileList: FileList | null) {
    const files = fileList ? Array.from(fileList) : [];
    const facility = this.facility as Facility;
    if (!facility.id || files.length === 0) {
      return;
    }
    this.$data.attachmentUploading = true;
    this.$data.attachmentUploadError = "";
    try {
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        this.$data.attachmentUploadMessage = `Uploading ${index + 1} of ${files.length}: ${file.name}`;
        await this.$store.dispatch(actions.UPLOAD_FILE, {
          image: file,
          imageComment: "",
          uploadName: file.name,
          tableName: "facility",
          recordId: facility.id,
          attachmentType: file.type.indexOf("image/") === 0 ? AttachmentType.IMAGE : AttachmentType.OTHER,
          success: noop
        });
      }
      this.$data.attachmentUploadMessage = `${files.length} ${files.length === 1 ? "attachment" : "attachments"} uploaded.`;
      this.$store.dispatch(actions.GET_FACILITY, { facilityId: facility.id });
    } catch (e) {
      this.$data.attachmentUploadError = `Error uploading attachments: ${e && e.message ? e.message : e}`;
    } finally {
      this.$data.attachmentUploading = false;
      this.$data.attachmentDragOver = false;
      this.$data.attachmentInputKey = this.$data.attachmentInputKey + 1;
      if (!this.$data.attachmentUploadError) {
        this.$data.showAttachmentDropZone = false;
      }
    }
  }

  async downloadDossier() {
    const facility = this.facility as Facility;
    if (!facility.id) {
      return;
    }
    this.$data.dossierBusy = true;
    this.$data.dossierError = "";
    try {
      const blob = await this.client.downloadFacilityDossier(facility.id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${facility.facilityCode || "facility"}-${facility.name}-dossier.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      this.$data.dossierError = await this.dossierErrorMessage(e);
    } finally {
      this.$data.dossierBusy = false;
    }
  }

  private async dossierErrorMessage(e: any): Promise<string> {
    const data = e && e.response && e.response.data;
    if (data instanceof Blob) {
      const text = await this.readBlobText(data);
      if (text) {
        return `Error creating dossier: ${text}`;
      }
    }
    return `Error creating dossier: ${e && e.message ? e.message : e}`;
  }

  private readBlobText(blob: Blob): Promise<string> {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = () => resolve((reader.result || "").toString());
      reader.onerror = () => resolve("");
      reader.readAsText(blob);
    });
  }

  recordLocation() {
    addLocationToGeoLocatable<Facility>(this.facility)
      .then(toSave =>
        this.$store.dispatch(actions.CREATE_OR_UPDATE_FACILITY, {
          toSave,
          success: noop
        })
      )
      .catch(positionError => {
        alert(`Error getting position ${JSON.stringify(positionError)}`);
        console.error(positionError);
      });
  }
}
